// extracted by mini-css-extract-plugin
export var searchHeader = "_4u-0";
export var searchHeaderDark = "_4u-1";